import { render } from "./BaseScaffold.vue?vue&type=template&id=9aa8a386"
import script from "./BaseScaffold.vue?vue&type=script&lang=js"
export * from "./BaseScaffold.vue?vue&type=script&lang=js"

import "./BaseScaffold.vue?vue&type=style&index=0&id=9aa8a386&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__